<app-loader [Parent]="this"></app-loader>
@if (FormLoaded) {
  <div [formGroup]="Form">
    <app-pageheader [Parent]="this">
      <app-form-save-button [Parent]="this" [Form]="Form" class="button is-primary" (OnSave)="Save()">
      </app-form-save-button>
    </app-pageheader>
    <div class="columns">
      <div class="column is-6">
        <article class="panel">
          <p class="panel-heading">
            Data Feed Details
          </p>
          <div class="panel-block" style="display: block;">
            <app-field Label="Description">
              <div class="control">
                <input formControlName="Description" class="input" placeholder="Leave blank to auto-generate" maxlength="128">
                <app-validator [For]="Form.get('Description')"></app-validator>
              </div>
            </app-field>
            <app-field Label="Feed Target">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="DataFeedTarget" class="input" [disabled]="!ModelIsNew">
                    <option value="kinesis">AWS Kinesis</option>
                    <option value="sftp">SFTP</option>
                  </select>
                  <app-validator [For]="Form.get('DataFeedTarget')"></app-validator>
                </div>
              </div>
            </app-field>
            <app-field Label="Feed Type">
              <div class="control">
                <div class="select is-fullwidth">
                  <select formControlName="FeedType" class="input">
                    <option [ngValue]="0">Spaces</option>
                    <option [ngValue]="1">Region</option>
                  </select>
                  <app-validator [For]="Form.get('FeedType')"></app-validator>
                </div>
              </div>
            </app-field>
            @if (isKinesisTarget()) {
              <app-field Label="AWS Key">
                <div class="control">
                  <input formControlName="AWSKey" class="input" maxlength="128">
                  <app-validator [For]="Form.get('AWSKey')"></app-validator>
                </div>
              </app-field>
              <app-field Label="AWS Secret">
                <div class="control">
                  <div class="field has-addons">
                    <div class="control is-expanded">
                      <input formControlName="AWSSecret" class="input" [type]="showSecret ? 'text' : 'password'" maxlength="128">
                      <app-validator [For]="Form.get('AWSSecret')"></app-validator>
                    </div>
                    <div class="control">
                      <button type="button" class="button" (click)="toggleSecretVisibility()">
                        <span class="icon is-small">
                          <i class="fas" [ngClass]="showSecret ? 'fa-eye-slash' : 'fa-eye'"></i>
                        </span>
                      </button>
                    </div>
                  </div>
                </div>
              </app-field>
              <app-field Label="AWS Endpoint">
                <div class="control">
                  <div class="select is-fullwidth">
                    <select formControlName="AWSEndpoint" class="input">
                      <option value="" disabled>Select an endpoint</option>
                      @for (endpoint of awsEndpoints; track endpoint) {
                        <option [value]="endpoint.Value">
                          {{endpoint.Name}} ({{endpoint.Value}})
                        </option>
                      }
                    </select>
                    <app-validator [For]="Form.get('AWSEndpoint')"></app-validator>
                  </div>
                </div>
              </app-field>
              <app-field Label="Stream Name">
                <div class="control">
                  <input formControlName="StreamName" class="input" maxlength="256">
                  <app-validator [For]="Form.get('StreamName')"></app-validator>
                </div>
              </app-field>
              <app-field Label="Partition Key">
                <div class="control">
                  <input formControlName="PartitionKey" class="input" maxlength="243">
                  <app-validator [For]="Form.get('PartitionKey')"></app-validator>
                </div>
              </app-field>
            }
            @if (isSFTPTarget()) {
              <app-field Label="SFTP Host">
                <div class="control">
                  <input formControlName="SFTPHost" class="input" maxlength="256">
                  <app-validator [For]="Form.get('SFTPHost')"></app-validator>
                </div>
              </app-field>
              <app-field Label="Path">
                <div class="control">
                  <input formControlName="SFTPPath" class="input" maxlength="128">
                  <app-validator [For]="Form.get('SFTPPath')"></app-validator>
                </div>
              </app-field>
              <app-field Label="SFTP Username">
                <div class="control">
                  <input formControlName="SFTPUsername" class="input" maxlength="128">
                  <app-validator [For]="Form.get('SFTPUsername')"></app-validator>
                </div>
              </app-field>
              <app-field Label="SFTP Password">
                <div class="control">
                  <input formControlName="SFTPPassword" class="input" maxlength="128">
                  <app-validator [For]="Form.get('SFTPPassword')"></app-validator>
                </div>
              </app-field>
              <app-field Label="SFTP Key">
                <div class="control">
                  <!-- Hidden input to store the key value -->
                  <input formControlName="SFTPKey" type="hidden">
                  <div class="field">
                    <!-- Key status and replace button -->
                    <div class="is-flex is-align-items-center">
                      @if (hasExistingKey) {
                        <span class="mr-2">
                          <i class="fas fa-key mr-1"></i>
                          <span>Key provided</span>
                        </span>
                      }
                      @if (!hasExistingKey) {
                        <span class="mr-2">
                          <i class="fas fa-exclamation-triangle mr-1 has-text-warning"></i>
                          <span>No key uploaded</span>
                        </span>
                      }
                      <button type="button" class="button is-small" (click)="toggleKeyFileInput()">
                        {{ showKeyFileInput ? 'Cancel' : (hasExistingKey ? 'Replace Key' : 'Upload Key') }}
                      </button>
                    </div>
                    <!-- File input (shown/hidden based on showKeyFileInput) -->
                    @if (showKeyFileInput) {
                      <div class="mt-2">
                        <div class="file has-name is-fullwidth">
                          <label class="file-label">
                            <input class="file-input" type="file" (change)="handleKeyFileUpload($event)">
                            <span class="file-cta">
                              <span class="file-icon">
                                <i class="fas fa-upload"></i>
                              </span>
                              <span class="file-label">
                                Choose a key file…
                              </span>
                            </span>
                          </label>
                        </div>
                        <p class="help">Upload your private key file (.pem, .ppk, etc.)</p>
                      </div>
                    }
                    <app-validator [For]="Form.get('SFTPKey')"></app-validator>
                  </div>
                </div>
              </app-field>
              <app-field Label="Dispatch Schedule">
                <div class="control">
                  <app-recurring-schedule formControlName="DispatchSchedule" [allowTimeOfDay]="false"></app-recurring-schedule>
                  <app-validator [For]="Form.get('DispatchSchedule')"></app-validator>
                </div>
              </app-field>
            }
            <app-field Label="Parking Structures" [HasAddons]="true" tippy="Select the parking structures to include in this data feed.">
              <div class="control">
                <div class="field is-grouped is-grouped-multiline">
                  @for (structure of this.FormArray(this.Form, 'Structures').controls; track structure; let i = $index) {
                    <div class="tags has-addons">
                      <a class="tag">{{structure.value.Name}}</a>
                      <a class="tag is-delete" (click)="removeStructure(i)"></a>
                    </div>
                  }
                  <div class="tags has-addons">
                    <a class="tag button is-primary" (click)="SelectParkingStructure()">Add Structures</a>
                  </div>
                </div>
                <app-validator [For]="Form.get('Structures')"></app-validator>
              </div>
            </app-field>
          </div>
        </article>
      </div>
      <div class="column is-6">
        <article class="panel is-info">
          <p class="panel-heading">
            Information
          </p>
          <div class="panel-block" style="display: block;">
            <div class="content">
              <!-- Kinesis Information -->
              @if (isKinesisTarget()) {
                <div>
                  <p>
                    Kinesis feeds allow you to stream parking data to AWS Kinesis for real-time processing and analytics.
                  </p>
                  <div class="mt-4">
                    <h5 class="title is-6 mb-2">Feed Types</h5>
                    <div class="ml-4">
                      <ul>
                        <li><strong>Spaces:</strong> Streams individual parking space status changes</li>
                        <li><strong>Region:</strong> Streams aggregated data for the entire parking structure</li>
                      </ul>
                    </div>
                  </div>
                  <div class="mt-4">
                    <h5 class="title is-6 mb-2">Partition Key Format</h5>
                    <div class="ml-4">
                      <p>Partition Key will be appended with date when data is sent. <span class="ml-2 is-size-7 has-text-grey-dark">(Date Format: yyyyMMddHHmm)</span></p>
                      <div class="is-flex is-align-items-center mt-2">
                        <span class="is-size-7 has-text-grey-dark mr-2">Eg, if sent now:</span>
                        <span class="tag is-normal is-family-monospace">
                          {{this.Form.get("PartitionKey")?.value ?? "PartitionKey"}}<span class="has-text-weight-bold">-{{ currentDate | date:'yyyyMMddHHmm' }}</span>
                        </span>
                      </div>
                    </div>
                  </div>
                  <div class="notification is-light is-warning mt-4 is-size-7 py-2 px-3">
                    <p><strong>Important:</strong> Ensure your AWS credentials have the appropriate permissions to write to the specified Kinesis stream.</p>
                  </div>
                </div>
              }
              <!-- SFTP Information -->
              @if (isSFTPTarget()) {
                <div>
                  <p>
                    SFTP feeds allow you to send parking data to a remote server via Secure File Transfer Protocol.
                  </p>
                  <div class="mt-4">
                    <h5 class="title is-6 mb-2">Dispatch Schedule</h5>
                    <div class="ml-4">
                      <p>Configure how often data should be sent to the SFTP server.</p>
                      <p class="is-size-7 has-text-grey-dark mr-2">Transfers typically occur at midnight.</p>
                    </div>
                  </div>
                  <div class="mt-4">
                    <h5 class="title is-6 mb-2">File Format</h5>
                    <div class="ml-4">
                      <p>Data will be sent as JSON files with the following structure:</p>
                      @if (getCurrentFeedType() === 0) {
                        <div class="notification is-light p-3 mt-2">
                          <pre class="is-family-monospace is-size-7">{{spacesFormatExample}}</pre>
                        </div>
                      }
                      @if (getCurrentFeedType() === 1) {
                        <div class="notification is-light p-3 mt-2">
                          <pre class="is-family-monospace is-size-7">{{regionFormatExample}}</pre>
                        </div>
                      }
                    </div>
                  </div>
                  <div class="notification is-light is-warning mt-4 is-size-7 py-2 px-3">
                    <p><strong>Important:</strong> Ensure the SFTP server is properly configured to accept connections and that the provided key has the necessary permissions.</p>
                  </div>
                </div>
              }
            </div>
          </div>
        </article>
      </div>
    </div>
  </div>
}
